import { Controller } from '@hotwired/stimulus'

export default class ConektaPaymentController extends Controller {
  static targets = ['submitButton', 'errors', 'conektaTokenId']

  connect () {
    this.insideModal = this.data.get('insideModal') === 'true'
    this.nativeApp = this.data.get('nativeApp') === 'true'
    this.testMode = this.data.get('testMode') === 'true'
  }

  conektaSuccessResponseHandler = event => token => {
    this.updateFormHiddenValues(token)

    if (this.insideModal && !this.nativeApp) {
      this.submitRemoteModal(event)
    } else {
      this.element.requestSubmit()
    }
  }

  conektaErrorResponseHandler = event => response => {
    // So far this is the only way I can mock this section of the app
    // in order to test the full workflow of entering your credit card
    // and making an order.
    if (this.testMode) {
      const conektaTestTokenID = { id: 'tok_2oSqV3MtZ1pyEaZch' }
      this.conektaSuccessResponseHandler(event)(conektaTestTokenID)
      return
    }

    this.errorsTarget.textContent = response.message_to_purchaser
    this.errorsTarget.classList.remove('hidden')

    setTimeout(() => {
      this.submitButtonTarget.classList.remove('btn-loading')
      this.submitButtonTarget.removeAttribute('disabled')
    }, 200)
  }

  submit = async event => {
    if (!this.element.reportValidity()) {
      return
    }

    Conekta.setPublicKey(this.data.get('publicKey'))

    event.preventDefault()
    event.stopPropagation()
    this.submitButtonTarget.classList.add('btn-loading')
    this.submitButtonTarget.setAttribute('disabled', '')

    Conekta.Token.create(
      this.element,
      this.conektaSuccessResponseHandler(event),
      this.conektaErrorResponseHandler(event)
    )
  }

  updateFormHiddenValues (token) {
    this.conektaTokenIdTarget.setAttribute('value', token.id)
  }

  /**
   * When the credit card submission is sucessfull and the form is inside
   * a Modal we need to call the modal#submit method to handle form
   * form errors and redirection.
   */
  submitRemoteModal (event) {
    const remoteModalNode = document.querySelector('[data-controller*="modal"]')

    const remoteModalController = this.application.getControllerForElementAndIdentifier(
      remoteModalNode,
      'modal'
    )
    remoteModalController.submit(event)
  }
}
